const uploadlogo = {
upload_logo :"./Images/upload_logo/upload.png"
};
export default uploadlogo;

